import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SosAlert } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSosService {
  private baseUrl = `${environment.apiBaseUrl}/admin/sos`;

  constructor(private http: HttpClient) {}

  getSosAlerts(): Observable<PaginatedResponse<SosAlert>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  updateSosStatus(id: number, status: string): Observable<SosAlert> {
    return this.http.put<ApiResponse<SosAlert>>(`${this.baseUrl}/${id}/status`, { status }).pipe(
      map(res => res.data)
    );
  }
}
